/**
 * @generated SignedSource<<dab20a1a93eb1a576be38284b638f0c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type loomPersonalization_permission$data = {
  readonly bulkPermitted: ReadonlyArray<{
    readonly permissionId: string | null;
    readonly permitted: boolean | null;
    readonly principalId: string | null;
    readonly resourceId: string | null;
  } | null> | null;
  readonly " $fragmentType": "loomPersonalization_permission";
};
export type loomPersonalization_permission$key = {
  readonly " $data"?: loomPersonalization_permission$data;
  readonly " $fragmentSpreads": FragmentRefs<"loomPersonalization_permission">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "loomPersonalization_permission"
};

(node as any).hash = "8a3a485648a25f46221be7f02c3e83e9";

export default node;
